<template>
  <v-app-bar
    :dark="isDarkTheme"
    :light="!isDarkTheme"
    color="transparent"
    absolute
    outlined
    elevation="0"
    app
    height="80px"
  >
    <v-toolbar-title class="brand" @click="gotoHome()">
      <img class="mt-1" :src="themeLogo" />
    </v-toolbar-title>
    <v-spacer></v-spacer>

    <!-- MOBIL -->
    <v-menu offset-y v-if="!loggedIn">
      <template v-slot:activator="{ on }">
        <v-btn class="hidden-md-and-up head-menu" text v-on="on">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item @click="gotoHome">
          <v-list-item-title>{{ $t('components.head.menu.home') }}</v-list-item-title>
        </v-list-item>
        <div class="mx-2 bottom-divider"></div>
        <v-list-item @click="gotoContactUs">
          <v-list-item-title>{{ $t('components.head.menu.contactUs') }}</v-list-item-title>
        </v-list-item>
        <div class="mx-2 bottom-divider"></div>
        <v-list-item @click="gotoAboutUs">
          <v-list-item-title>{{ $t('components.head.menu.aboutUs') }}</v-list-item-title>
        </v-list-item>
        <div class="mx-2 bottom-divider"></div>
        <v-list-item class="minheight-auto my-2">
          <v-list-item-subtitle>{{ $t('components.head.menu.journalist') }}</v-list-item-subtitle>
        </v-list-item>
        <v-list-item class="minheight-36" @click="loginUser">
          <v-list-item-title>{{ $t('components.head.menu.loginAsJournalist') }}</v-list-item-title>
        </v-list-item>
        <v-list-item class="minheight-36 mb-3" @click="signupUser">
          <v-list-item-title>{{ $t('components.head.menu.createAccoutAsJournalist') }}</v-list-item-title>
        </v-list-item>
        <div class="mx-2 bottom-divider"></div>
        <v-list-item class="minheight-auto my-2">
          <v-list-item-subtitle>{{ $t('components.head.menu.company') }}</v-list-item-subtitle>
        </v-list-item>
        <v-list-item class="minheight-36" @click="loginVendor">
          <v-list-item-title>{{ $t('components.head.menu.loginAsCompany') }}</v-list-item-title>
        </v-list-item>
        <v-list-item class="minheight-36 mb-3" @click="gotoVendorPriceSignup">
          <v-list-item-title>{{ $t('components.head.menu.createAccountAsCompany') }}</v-list-item-title>
        </v-list-item>
        <div class="mx-2 bottom-divider"></div>
        <v-list-item @click="changeLanguage()">
          <v-list-item-title><v-img :src="languageFlag" max-width="18" class="mr-1 d-inline-block"></v-img>{{languageText}}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-menu offset-y v-if="loggedIn" min-width="200">
      <template v-slot:activator="{ on }">
        <v-btn class="hidden-md-and-up" text v-on="on">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item @click="gotoHome">
          <v-list-item-title>{{ $t('components.head.menu.home') }}</v-list-item-title>
        </v-list-item>
        <div class="mx-2 bottom-divider"></div>
        <v-list-item @click="gotoAboutUs">
          <v-list-item-title>{{ $t('components.head.menu.aboutUs') }}</v-list-item-title>
        </v-list-item>
        <div class="mx-2 bottom-divider"></div>
        <v-list-item @click="gotoContactUs">
          <v-list-item-title>{{ $t('components.head.menu.contactUs') }}</v-list-item-title>
        </v-list-item>
        <div class="mx-2 bottom-divider"></div>
        <v-list-item @click="showCompanySelector()" v-if="isVendor() && hasManyCompanies()">
          <v-list-item-title>{{ $t('components.head.menu.switchCompany') }}</v-list-item-title>
        </v-list-item>
        <v-list-item @click="gotoMyProfile()" v-if="isVendor()">
          <v-list-item-title>{{ $t('components.head.menu.myProfile') }}</v-list-item-title>
        </v-list-item>
        <v-list-item @click="gotoMyImages()" v-if="isVendor()">
          <v-list-item-title>{{ $t('components.head.menu.myImages') }}</v-list-item-title>
        </v-list-item>
        <v-list-item @click="editUserDialog()" v-if="!isVendor()">
          <v-list-item-title>{{ $t('components.head.menu.myProfile') }}</v-list-item-title>
        </v-list-item>
        <div class="mx-2 bottom-divider"></div>
        <v-list-item @click="changeLanguage()">
          <v-list-item-title><v-img :src="languageFlag" max-width="18" class="mr-1 d-inline-block"></v-img>{{languageText}}</v-list-item-title>
        </v-list-item>
        <div class="mx-2 bottom-divider"></div>
        <v-list-item @click="logoutUser()">
          <v-list-item-title>{{ $t('components.head.menu.logout') }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <!-- /MOBIL -->

    <!-- DESKTOP -->

    <div class="d-md-flex head-menu hidden-sm-and-down">
      <v-btn @click="gotoHome" class="mr-1 hidden-sm-and-down" text>{{ $t('components.head.menu.home') }}</v-btn>
      <div class="divider mr-1 hidden-sm-and-down"></div>
      <v-btn @click="gotoContactUs" class="mr-1 hidden-sm-and-down" text>{{ $t('components.head.menu.contactUs') }}</v-btn>
      <div class="divider mr-1 hidden-sm-and-down"></div>
      <v-btn @click="gotoAboutUs" class="mr-1 hidden-sm-and-down" text>{{ $t('components.head.menu.aboutUs') }}</v-btn>
      <div class="divider mr-1 hidden-sm-and-down"></div>

      <div>
        <v-menu offset-y v-if="!loggedIn">
          <template v-slot:activator="{ on }">
            <v-btn text class="hidden-sm-and-down" v-on="on">{{ $t('components.head.menu.createAccount') }}</v-btn>
          </template>

          <v-list>
            <v-list-item @click="signupUser">
              <v-list-item-title>{{ $t('components.head.menu.createAccoutAsJournalist') }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="gotoVendorPriceSignup">
              <v-list-item-title>{{ $t('components.head.menu.createAccountAsCompany') }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <div class="divider mr-1 hidden-sm-and-down" v-if="!loggedIn"></div>

      <div>
        <v-menu offset-y v-if="!loggedIn">
          <template v-slot:activator="{ on }">
            <v-btn class="mr-4 hidden-sm-and-down" text v-on="on">{{ $t('components.head.menu.login') }}</v-btn>
          </template>

          <v-list>
            <v-list-item @click="loginUser">
              <v-list-item-title>{{ $t('components.head.menu.loginAsJournalist') }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="loginVendor">
              <v-list-item-title>{{ $t('components.head.menu.loginAsCompany') }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-menu offset-y v-if="loggedIn">
          <template v-slot:activator="{ on }">
            <v-btn text class="hidden-sm-and-down" v-on="on"
              ><v-icon class="mr-2">mdi-account</v-icon> {{ userStore.user.name }} {{ companyName }}
              <v-icon>mdi-chevron-down</v-icon></v-btn
            >
          </template>
          <v-list>
            <v-list-item @click="showCompanySelector()" v-if="isVendor() && hasManyCompanies()">
              <v-list-item-title>{{ $t('components.head.menu.switchCompany') }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="gotoMyProfile()" v-if="isVendor()">
              <v-list-item-title>{{ $t('components.head.menu.myProfile') }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="gotoMyImages()" v-if="isVendor()">
              <v-list-item-title>{{ $t('components.head.menu.myImages') }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="editUserDialog()" v-if="!isVendor()">
              <v-list-item-title>{{ $t('components.head.menu.myProfile') }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="logoutUser()">
              <v-list-item-title>{{ $t('components.head.menu.logout') }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <div class="divider mr-1 hidden-sm-and-down"></div>
      <v-btn @click="changeLanguage" class="mr-1 hidden-sm-and-down" text><v-img :src="languageFlag" max-width="18" class="mr-1"></v-img>{{languageText}}</v-btn>
    </div>
    <!-- /DESKTOP -->

    <login-dialog-component
      :visible="showLoginDialog"
      :vendor="loginAsVendor"
      @success="loginSuccess"
      @close="showLoginDialog = false"
    ></login-dialog-component>

    <signup-dialog :visible="showSignupDialog" @close="signupClosed()"></signup-dialog>
    <user-edit-dialog-component :visible="showUserEditDialog" @close="editUserClosed()"></user-edit-dialog-component>

    <company-select-dialog
      :visible="showCompanySelectDialog"
      @close="companySelectDialogClosed"
    ></company-select-dialog>
  </v-app-bar>
</template>

<script>
import LoginDialogComponent from './dialog/LoginDialogComponent.vue';
import SignupDialog from './dialog/SignupDialogComponent.vue';
import CompanySelectDialog from './dialog/CompanySelectDialogComponent.vue';
import UserEditDialogComponent from './dialog/UserEditDialogComponent.vue';
import { mapStores } from 'pinia';
import { useUserStore } from '../stores/UserStore';
import { useFilterStore } from '../stores/FilterStore';
import { useLookupStore } from '../stores/LookupStore';
import { setLocale } from '../services/locale.service';
import { useNewsStore } from '../stores/NewsStore';

export default {
  components: {
    LoginDialogComponent,
    SignupDialog,
    CompanySelectDialog,
    UserEditDialogComponent,
  },

  watch: {
    $route: function (value) {
      const meta = (value && value.meta) || {};
      const theme = meta.headerTheme || 'light';
      this.headerTheme = theme;
    },
  },

  data() {
    return {
      showLoginDialog: false,
      showVendorSignupDialog: false,
      showSignupDialog: false,
      showCompanySelectDialog: false,
      showUserEditDialog: false,
      loginAsVendor: false,
      showContactUs: false,
      headerTheme: 'dark',
    };
  },

  computed: {
    ...mapStores(useUserStore, useFilterStore, useLookupStore, useNewsStore),

    isDarkTheme() {
      return this.headerTheme === 'dark';
    },
    themeLogo() {
      return this.isDarkTheme
        ? '/images/pretopia_hori_fylld_payoff_vit.png'
        : '/images/pretopia_hori_fylld_payoff_svart.png';
    },
    themeTextColor() {
      return this.isDarkTheme ? 'theme--dark' : 'theme--light';
    },
    loggedIn() {
      return this.userStore.isAuthenticated;
    },
    companies() {
      return this.userStore.companies || [];
    },
    companyName() {
        return this.userStore.selectedCompanyName;
    },
    languageText() {
      return this.$i18n.locale === 'sv-SE' ? 'English' : 'Svenska';
    },
    languageFlag() {
      return this.$i18n.locale === 'sv-SE' ? '/images/gb.svg' : '/images/se.svg';
    },
  },

  methods: {
    logoutUser() {
      if (this.$route.name === 'Home') {
        return this.userStore.signOut();
      }

      this.$router.push({ name: 'Home' }).then(() => {
        return this.userStore.signOut()
      })
    },

    loginVendor() {
      this.loginAsVendor = true;
      this.showLoginDialog = true;
    },

    loginUser() {
      this.loginAsVendor = false;
      this.showLoginDialog = true;
    },

    signupUser() {
      this.showSignupDialog = true;
    },

    signupClosed() {
      this.showSignupDialog = false;
    },

    gotoHome() {
      if (this.$route.name === 'Home') {
        // Om vi är på home så ska sidan rensas
        this.filterStore.reset();
        return;
      }
      this.$router.push({ name: 'Home' }).catch(this.navigationErrorHandler);
    },

    gotoMyProfile() {
      this.$router.push({ name: 'Dashboard' }).catch(this.navigationErrorHandler);
    },

    gotoMyImages() {
      this.$router.push({ name: 'List' }).catch(this.navigationErrorHandler);
    },

    gotoAboutUs() {
      this.$router.push({ name: 'AboutUs' }).catch(this.navigationErrorHandler);
    },

    gotoContactUs() {
      this.$router.push({ name: 'ContactUs' }).catch(this.navigationErrorHandler);
    },

    gotoVendorPriceSignup() {
      this.$router.push({ name: 'VendorPrice' }).catch(this.navigationErrorHandler);
    },

    isVendor() {
      return this.userStore.isAuthenticatedVendor;
    },

    hasManyCompanies() {
      return this.userStore.hasManyCompanies;
    },

    showCompanySelector() {
      this.showCompanySelectDialog = true;
    },

    companySelectDialogClosed() {
      this.showCompanySelectDialog = false;
    },

    editUserDialog() {
      this.showUserEditDialog = true;
    },

    editUserClosed() {
      this.showUserEditDialog = false;
    },

    loginSuccess(event) {
      if (event.vendor && event.gotoMyProfile !== false) {
        this.gotoMyProfile();
      }
    },

    navigationErrorHandler(error) {
      if (error && error.name === 'NavigationDuplicated') {
        return;
      }
      throw error;
    },

    changeLanguage() {
      this.$i18n.locale = this.$i18n.locale === 'sv-SE' ? 'en-US' : 'sv-SE';
      setLocale(this.$i18n.locale);

      // Reset lookup and filter store and reload data
      this.filterStore.reset();
      this.lookupStore.$reset();
      this.lookupStore.loadCountries();
      this.lookupStore.load(this.$i18n.t.bind(this.$i18n));
      this.newsStore.forceReloadLatest();
    },
  },
};
</script>

<style lang="scss" scoped>
.brand {
  cursor: pointer;

  img {
    height: 45px;
  }
}
@media screen and (min-width: 768px) {
  .brand {
    img {
      height: 60px;
    }
  }
}

.divider {
  border-right: 2px solid #d1bf89;
  height: 30px;
}
.bottom-divider {
  border-bottom: 1px solid #d1bf89;
}
.minheight-auto {
  min-height: auto !important;
}
.minheight-36 {
  min-height: 36px !important;
}
.msv {
  min-width: 100px !important;
}
.head-menu {
  background-color: #fffd;
  border-radius: 15px;
  padding: 7px 10px 7px 15px;

  button {
    font-size: 1rem;
  }
}
</style>
